export default {
  //结算方式
  settlementMode: [{
    text: '次结',
    value: 0,
  }, {
    text: '月结',
    value: 1,
  }, {
    text: '季结',
    value: 2,
  }, {
    text: '半年结',
    value: 3,
  }, {
    text: '年结',
    value: 4,
  }],

  //开票状态
  recordStatus: [{
    text: '未申请',
    value: 0,
  }, {
    text: '开票中',
    value: 1,
  }, {
    text: '已驳回',
    value: -1,
  }, {
    text: '已开票',
    value: 2,
  }],

  //需求列表处理状态
  handleStatus: [{
    status: '全部',
    id: null
  }, {
    status: '未处理',
    id: 0
  }, {
    status: '已处理',
    id: 1
  }],
  //用户身份
  userJob: [{
    job: '学生',
    id: 0
  }, {
    job: '教职工',
    id: 1
  }, {
    job: '企业',
    id: 2
  }, {
    job: "个人",
    id: 4
  },{
    job: "事业单位",
    id: 5
  }],
  //企业测
  userJobQYC: [{
    job: '企业',
    id: 2
  }, {
    job: "个人",
    id: 4
  }],
  //用户学历
  degreeList: [{
    degree: '本科',
    id: 0
  }, {
    degree: '硕士',
    id: 1
  }, {
    degree: '博士',
    id: 2
  }, {
    degree: "专科",
    id: -1
  }],
  //信用金状态
  reviewStatus: [{
    status: '未处理',
    id: 0
  }, {
    status: '已通过',
    id: 1
  }, {
    status: '已驳回',
    id: -1
  }],
  //是否下拉框
  selectedArr: [{
    key: '是',
    value: true
  }, {
    key: '否',
    value: false
  }],
  //对公款项状态
  transferPayStatusArr: [{
    text: '非对公',
    value: -1,
  }, {
    text: '未分配',
    value: 0,
  }, {
    text: '已到账',
    value: 1,
  }, {
    text: '待审核',
    value: 2,
  }, {
    text: '分配中',
    value: 3,
  }, {
    text: '部分到账',
    value: 4,
  }],
}



// WEBPACK FOOTER //
// ./src/common/constData.js